export function MechanicLookupCtrl (
  $filter,
  $rootScope,
  $scope,
  $translate,
  $uibModalInstance,
  mechanics,
  messages,
  workshopAPI
) {
  $scope.mechanics = mechanics;

  $scope.selectedItem = null;

  $scope.tableSettings = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('EMPLOYEE_SPACE.EMPLOYEE', {
            title: $rootScope.Company.labels.employeeTitle
          })
        }
      },
      {
        field : 'mobile',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.MOBILE')
        },
        pipe  : 'mobilePhone'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
        type: $rootScope.Company.labels.employeeTitle
          ? $filter('pluralize')($rootScope.Company.labels.employeeTitle)
          : $translate.instant('EMPLOYEE_SPACE.EMPLOYEES')
      })
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.getMechanics = ( params ) => {
    return workshopAPI.get('/mechanics', [
      0,
      params.offset,
      '*',
      params.direction,
      params.field,
    ]).then(function (mechanics) {
      $scope.mechanics = mechanics;
      if (!$scope.$$phase) {
        $scope.$apply();
      }
      return mechanics
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.select = function () {
    $uibModalInstance.close($scope.selectedItem);
  };

  $scope.onRowClick = function (event) {
    if ($scope.selectedItem && event.row.id === $scope.selectedItem.id) {
      $scope.selectedItem = null;
    }
    else {
      $scope.selectedItem = event.row;
    }
  };

  $scope.onRowDoubleClick = function (event) {
    $uibModalInstance.close(event.row);
  };
};